import React, { useState } from "react";
import { Typography, Icon } from "@mui/material";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { CATEGORY_SAVING, GENERAL_SAVING } from "../redux/constant";
import {
  getWithdrawalBankList,
  getWithdrawalBankAccount,
  getTransactionHistory,
  hideError,
  getWithdrawalResult,
  resetCategorySaving,
  resetGeneralSaving,
  resetMaxAmount,
} from "../redux/action";
import withProfileRedirect from "../../containers/App/withProfileRedirect";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";

import {
  StepLabel,
  CustomButton,
  CustomInput,
  Dropdown,
  DefaultLoader,
  Alert,
  ButtonWrapper,
} from "../../components";
import { useEffect } from "react";
import { sendFundsCode } from "../fundSelection/redux/action";
import { Container, Row } from "./styles";
import { showError } from "../../globalRedux/actions";
import useModal from "../../utils/hooks/useModal";
import FnzTimeoutPopup from "../../components/FnzTimeoutPopup";

const BankInformation = props => {
  const {
    profile,
    savingGoalDetails,
    generalSavingDetails,
    isFullRedemption,
    savingType,
    withdrawalBankList,
    withdrawalBankAccount,
    getWithdrawalBankAccount,
    getTransactionHistory,
    getWithdrawalResult,
    transactionHistory,
    history,
    match: {
      params: { amount },
    },
    fund,
    sendFundsCode,
    resetMaxAmount,
    resetCategorySaving,
    resetGeneralSaving,
    loadingWithdrawalBankAccount,
    loadingTransactionHistory,
    getWithdrawalBankList,
    loadingWithdrawalBankList,
    showError,
  } = props;

  const [bank, setBank] = useState({
    bankCd: "",
    bankName: "",
    accountNumber: "",
    fee: 0,
  });
  const [isBankListOpen, setBankListOpen] = useState(false);
  const [goalDetails, setGoalDetails] = useState(null);
  const [bankAccount, setBankAccount] = useState(null);
  const [apiError, setApiError] = useState({
    message: "",
    isError: false,
  });
  const [disabled, setDisabled] = useState(false);
  const [formStatus, setFormStatus] = useState("idle");
  const {
    open: isFnzTimeoutModalOpen,
    modalOpen: openFnzTimeoutModal,
    modalClose: closeFnzTimeoutModal,
  } = useModal();

  const fee = withdrawalBankList.length > 0 ? withdrawalBankList[0].fee : 0;

  useEffect(() => {
    getTransactionHistory({ size: 1, page: 1 });
    getWithdrawalBankList({ rsp: false });
  }, []);

  useEffect(() => {
    if (profile) {
      getWithdrawalBankAccount(profile.masterId);
    }
  }, [profile]);
  // }, []);

  useEffect(() => {
    if (withdrawalBankAccount.length > 0) {
      const lastTransaction = transactionHistory[0];
      if (lastTransaction) {
        const findedBankAccount = withdrawalBankAccount.find(
          el =>
            el.bankCode === lastTransaction.bankCd &&
            el.accountNo === lastTransaction.bankAccountNo
        );
        if (findedBankAccount) {
          setBankAccount(findedBankAccount);
        } else {
          setBankAccount(
            withdrawalBankAccount[withdrawalBankAccount.length - 1]
          );
        }
      }
    }
  }, [withdrawalBankAccount, transactionHistory]);

  useEffect(() => {
    if (bankAccount && withdrawalBankList.length > 0) {
      let bankInfo = withdrawalBankList.find(
        bank => bank.bankCd === bankAccount.bankCode
      );

      if (bankInfo) {
        setBank(prevState => ({
          ...prevState,
          bankCd: bankInfo.bankCdOrigin,
          bankName: bankInfo.name,
          fee: bankInfo.fee,
          accountNumber: bankAccount.accountNo,
        }));
      }
    }
  }, [bankAccount, withdrawalBankList]);

  /** Save saving goal data */
  useEffect(() => {
    if (savingType === CATEGORY_SAVING && savingGoalDetails) {
      setGoalDetails(savingGoalDetails);
    }
  }, [savingType, savingGoalDetails]);

  useEffect(() => {
    if (savingType === GENERAL_SAVING && generalSavingDetails) {
      setGoalDetails(generalSavingDetails);
    }
  }, [savingType, generalSavingDetails]);

  useEffect(() => {
    window.eventManager.on("WITHDRAWAL_SUCCESS", res => {
      resetCategorySaving();
      resetGeneralSaving();
      resetMaxAmount();
      sendFundsCode([]);
      getWithdrawalResult(res);
      history.push("/make-withdrawal/success");
    });

    window.eventManager.on("WITHDRAWAL_ERROR", res => {
      if (res) {
        setApiError(prev => ({ ...prev, message: res.message, isError: true }));
      }
      resetMaxAmount();
      setDisabled(false);
      setFormStatus("idle");
    });

    window.eventManager.on("WITHDRAWAL_PIN_ERROR", () => {
      setApiError(prev => ({
        ...prev,
        message: "Please try again",
        isError: true,
      }));
      setDisabled(false);
      setFormStatus("idle");
    });
    window.eventManager.on("WITHDRAWAL_PIN_CANCEL", () => {
      setDisabled(false);
      setFormStatus("idle");
    });
    window.eventManager.on("WITHDRAWAL_PIN_FAILED", () => {
      setDisabled(false);
      setFormStatus("idle");
    });
    window.eventManager.on("WITHDRAWAL_LOCK_FAILED", () => {
      setDisabled(false);
      setFormStatus("idle");
    });

    window.eventManager.on("FNZ_TIMEOUT", () => {
      openFnzTimeoutModal();
      setDisabled(false);
      setFormStatus("idle");
    });

    window.eventManager.on("WITHDRAWAL_PENDING", data => {
      /**
       * @remark see comment in file src/pages/withdrawal/pending.js on line 36
       */
      history.push("/make-withdrawal/pending", data);
    });

    // listen for duplicate transaction event from native and show duplicate transaction page with data from native
    window.eventManager.on("DUPLICATE_TRANSACTION_DETECTED", () => {
      history.push("/make-withdrawal/duplicate-transaction");
    });

    return () => {
      window.eventManager.clearAllEvents();
    };
  }, []);

  const handleChangeBank = e => {
    const { name, value } = e.target;

    const numericValue = value.replace(/[^0-9]/g, "");

    setBank(prevState => ({
      ...prevState,
      [name]: numericValue,
    }));
  };

  const handleCloseFnzTimeoutModal = () => {
    closeFnzTimeoutModal();
    history.push("/transaction");
  };

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    setFormStatus("submitting");

    const requiredPayload = {
      cifId: profile.masterId,
      cifPlanId: (goalDetails && goalDetails.id) || (fund && fund.cifPlanId),
      bankCd: bank.bankCd, //bankCdOrigin
      bankAccountNo: bank.accountNumber,
    };

    if (
      Object.values(requiredPayload).some(v => v?.trim()?.length === 0 || !v)
    ) {
      const date = new Date();

      window.log({
        path: window.location.pathname,
        status: "400",
        res: {},
        req: JSON.stringify(requiredPayload),
        requestDate: date,
        responseDate: date,
        responseTime: "0ms",
      });
      setDisabled(false);
      return;
    }

    const payload = {
      ...requiredPayload,
      amountCcy: "MYR",
      fee: bank.fee || fee,
      feeCcy: "MYR",
      fundCd: fund && fund.code,
    };

    if (isFullRedemption) {
      payload.percentage = 100;
      payload.amount = 0;

      /**
       * @remark see comment in file src/pages/withdrawal/pending.js on line 36
       */
      payload.maxAmount = parseFloat(amount.replace(/[^0-9\.]/gi, ""));
    } else {
      payload.amount = parseFloat(amount.replace(/[^0-9\.]/gi, ""));
    }

    window.verifyUser({
      api: "call",
      event: "verifyUser",
      payload,
    });
  };

  const handleBack = () => {
    history.back();
  };

  if (
    loadingTransactionHistory ||
    loadingWithdrawalBankAccount ||
    loadingWithdrawalBankList
  )
    return <DefaultLoader />;

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Alert
        title="Something went wrong"
        description={apiError.message}
        isOpen={apiError.isError}
        isCancel={false}
        handleAction={() => setApiError(prev => ({ ...prev, isError: false }))}
      />
      <FnzTimeoutPopup
        isOpen={isFnzTimeoutModalOpen}
        handleClose={handleCloseFnzTimeoutModal}
        handleRedirectToTransactionHistory={handleCloseFnzTimeoutModal}
      />

      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight * 0.6}
        isOpen={isBankListOpen}
        handleDismiss={() => setBankListOpen(false)}
      >
        <div style={{ padding: "16px 16px 0" }}>
          <Typography
            color="secondary"
            style={{ fontSize: "20px", fontWeight: 700, lineHeight: 1.4 }}
          >
            Bank list
          </Typography>
          {withdrawalBankList &&
            withdrawalBankList.length > 0 &&
            withdrawalBankList.map((bankItem, index) => {
              return (
                <Row
                  key={index}
                  data-cy={`bank-${bankItem.name}`}
                  onClick={() => {
                    setBank(prevState => ({
                      ...prevState,
                      bankCd: bankItem.bankCdOrigin,
                      bankName: bankItem.name,
                      fee: bankItem.custFee,
                    }));
                    setBankListOpen(false);
                  }}
                  style={{
                    justifyContent: "space-between",
                    margin: "32px 0",
                  }}
                >
                  <Typography color="textPrimary" style={{ fontWeight: "700" }}>
                    {bankItem.name}
                  </Typography>
                  {bank.bankName === bankItem.name && (
                    <DoneOutlinedIcon
                      sx={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}
                    />
                  )}
                </Row>
              );
            })}
        </div>
      </Dropdown>

      <Container>
        <StepLabel
          title="Insert bank information"
          containerStyles={{ margin: "16px 16px 22px" }}
          onClick={handleBack}
        />
        <form style={{ margin: "0 16px" }}>
          <CustomInput
            label="Bank name"
            name="bankName"
            value={bank.bankName}
            isDropdown={true}
            isEdit={true}
            onClick={() => setBankListOpen(true)}
          />
          <CustomInput
            label="Bank account number"
            name="accountNumber"
            value={bank.accountNumber}
            error={
              formStatus === "submitting" && bank.accountNumber.length === 0
            }
            helperError={
              formStatus === "submitting" &&
              bank.accountNumber.length === 0 &&
              "This field is required"
            }
            isEdit={true}
            onChange={handleChangeBank}
            onPaste={e => {
              e.preventDefault(); // stop the default paste
              const paste = e.clipboardData.getData("text");
              const numericValue = paste.replace(/[^0-9]/g, "");
              const { name } = e.target;

              // Manually update input and state
              setBank(prev => ({
                ...prev,
                [name]: numericValue,
              }));
            }}
          />
        </form>

        {/* Button */}
        <ButtonWrapper
          style={{
            backgroundColor: "#fff",
          }}
        >
          <CustomButton
            text="Next"
            variant="contained"
            color="#fff"
            backgroundColor="#1278cc"
            disabled={!bank.bankCd || !bank.accountNumber || disabled}
            onClick={handleSubmit}
          />
        </ButtonWrapper>
      </Container>
    </div>
  );
};

const withConnect = connect(
  state => ({
    profile: state.goal.profile,
    savingType: state.goal.savingType,
    savingGoalDetails: state.goal.savingGoalDetails,
    generalSavingDetails: state.goal.generalSavingDetails,
    withdrawalBankList: state.goal.withdrawalBankList,
    withdrawalBankAccount: state.goal.withdrawalBankAccount,
    transactionHistory: state.goal.transactionHistory.data,
    isFullRedemption: state.goal.isFullRedemption,
    fund: state.fundSelectionReducer.fundsCode[0],
    loadingTransactionHistory: state.goal.loadingTransactionHistory,
    loadingWithdrawalBankAccount: state.goal.withdrawalBankAccountLoading,
    loadingWithdrawalBankList: state.goal.loadingWithdrawalBankList,
  }),
  {
    getWithdrawalBankAccount,
    getTransactionHistory,
    getWithdrawalResult,
    hideError,
    sendFundsCode,
    resetMaxAmount,
    resetCategorySaving,
    resetGeneralSaving,
    getWithdrawalBankList,
    showError,
  }
);

export default compose(
  withRouter,
  withConnect,
  withProfileRedirect
)(BankInformation);
